var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9,
    r: 8.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 14.4L9.5 11.655L13.1 14.4L11.75 9.945L15.35 7.38H10.94L9.5 2.7L8.06 7.38H3.65L7.25 9.945L5.9 14.4ZM9.5 18C8.255 18 7.085 17.7636 5.99 17.2908C4.895 16.8186 3.9425 16.1775 3.1325 15.3675C2.3225 14.5575 1.6814 13.605 1.2092 12.51C0.7364 11.415 0.5 10.245 0.5 9C0.5 7.755 0.7364 6.585 1.2092 5.49C1.6814 4.395 2.3225 3.4425 3.1325 2.6325C3.9425 1.8225 4.895 1.1811 5.99 0.7083C7.085 0.2361 8.255 0 9.5 0C10.745 0 11.915 0.2361 13.01 0.7083C14.105 1.1811 15.0575 1.8225 15.8675 2.6325C16.6775 3.4425 17.3186 4.395 17.7908 5.49C18.2636 6.585 18.5 7.755 18.5 9C18.5 10.245 18.2636 11.415 17.7908 12.51C17.3186 13.605 16.6775 14.5575 15.8675 15.3675C15.0575 16.1775 14.105 16.8186 13.01 17.2908C11.915 17.7636 10.745 18 9.5 18ZM9.5 16.2C11.495 16.2 13.1939 15.4989 14.5967 14.0967C15.9989 12.6939 16.7 10.995 16.7 9C16.7 7.005 15.9989 5.3061 14.5967 3.9033C13.1939 2.5011 11.495 1.8 9.5 1.8C7.505 1.8 5.8064 2.5011 4.4042 3.9033C3.0014 5.3061 2.3 7.005 2.3 9C2.3 10.995 3.0014 12.6939 4.4042 14.0967C5.8064 15.4989 7.505 16.2 9.5 16.2Z",
    fill: "#FFC122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCheckedIcon);
export default __webpack_public_path__ + "static/media/StarCheckedIcon.b21d8de97742653e0a7363b6d002f7b3.svg";
export { ForwardRef as ReactComponent };